import React, { useEffect, useState } from 'react'

//Import JS breakpoints from HomeProducts.js
import { mobileMaxW } from './HomeProducts'
import { desktopMinW } from './HomeProducts'

const SectionBigTile = ({
  containerStyle = '',
  heading,
  content,
  icon1,
  icon2,
  icon3,
}) => {
  const [breakpoint, setBreakpoint] = useState('')

  useEffect(() => {
    checkBreakpoint()
    window.addEventListener('resize', () => {
      checkBreakpoint()
    })
  })

  const checkBreakpoint = () => {
    const desktopBreakpoint = window.matchMedia(desktopMinW)
    const mobileBreakpoint = window.matchMedia(mobileMaxW)
    if (desktopBreakpoint.matches) {
      setBreakpoint('desktop')
    }
    if (mobileBreakpoint.matches) {
      setBreakpoint('mobile')
    }
    if (!mobileBreakpoint.matches && !desktopBreakpoint.matches) {
      setBreakpoint('tablet')
    }
  }

  return (
    <div
      className={`${containerStyle} lg:pt-[90px] lg:pb-[140px] md:py-[65px] md:container px-[8px] pt-[50px] pb-[40px] bg-gray-100`}
      data-aos='fade-up'
      data-aos-duration='500'
      data-aos-easing='ease-in-out'
    >
      {breakpoint !== 'mobile' && (
        <h2 className='lg:max-w-[800px] md:max-w-[580px] md:block hidden text-5xl mb-[45px] text-center mx-auto'>
          {heading}
        </h2>
      )}
      <div className='md:pt-[60px] md:pb-[45px] md:flex md:items-center md:flex-col bg-white px-[16px] py-[40px] text-center text-black-100'>
        {breakpoint === 'mobile' && (
          <h2 className='md:hidden text-3xl'>{heading}</h2>
        )}
        <div className='md:pt-0 flex justify-center gap-[50px] py-[30px]'>
          {icon1}
          {icon2}
          {icon3}
        </div>
        <p className='lg:max-w-[800px] md:max-w-[550px] text-lg'>{content}</p>
      </div>
    </div>
  )
}

export default SectionBigTile
